// views/ForgotPassword/ForgotPassword.jsx
import './ForgotPassword.css';
import { useState, useContext } from 'react';
import { Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import PasswordRequirements from '../../components/PasswordRequirements/PasswordRequirements.jsx';
import AuthContext from '../../AuthContext.jsx';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { authService } = useContext(AuthContext);
  
  const [email, setEmail] = useState('');
  const [view, setView] = useState('forgot'); // forgot | reset | success
  const [err, setErr] = useState('');
  const [reset, setReset] = useState({ code:'', newPassword:'', confirmPassword:'' });
  const [sending, setSending] = useState(false);
  const [resetting, setResetting] = useState(false);

  /* ---------------- Handlers --------------- */
  const onEmailSubmit = async (e) => {
    e.preventDefault();
    if(!email) return setErr('Please enter your email');
    
    setSending(true);
    setErr('');
    
    try {
      console.log('🔄 Enviando forgot password para email:', email);
      const result = await authService.forgotPassword(email);
      console.log('✅ Forgot password exitoso:', result);
      setView('reset');
    } catch (error) {
      console.error('❌ Error en forgot password:', error);
      setErr(error.message || 'Something went wrong');
    } finally {
      setSending(false);
    }
  };

  const onResetSubmit = async (e) => {
    e.preventDefault();
    const { code, newPassword, confirmPassword } = reset;
    if(!code) return setErr('Enter the verification code');
    if(!newPassword) return setErr('Enter a new password');
    if(newPassword !== confirmPassword) return setErr('Passwords do not match');
    if(newPassword.length < 8) return setErr('Password must be at least 8 characters');
    
    setResetting(true);
    setErr('');
    
    try {
      console.log('🔄 Enviando reset password para email:', email);
      console.log('🔄 Código de verificación:', code.substring(0, 3) + '***');
      const result = await authService.resetPassword(email, code, newPassword);
      console.log('✅ Reset password exitoso:', result);
      setView('success');
    } catch (error) {
      console.error('❌ Error en reset password:', error);
      setErr(error.message || 'Failed to reset password');
    } finally {
      setResetting(false);
    }
  };

  const onResetChange = e => setReset({ ...reset, [e.target.name]: e.target.value });

  /* ------------------- UI ------------------ */
  return (
    <>
      <div className="forgot-password-container">

        <div className="auth-card">
          {/* ---------- FORGOT ---------- */}
          {view==='forgot' && (
            <form onSubmit={onEmailSubmit} className="card-form">
              <div className="icon-circle"><Lock size={32} strokeWidth={1.8}/></div>
              <h2 className="card-title">Trouble logging in?</h2>
              <p className="card-text">
                Enter your email and we’ll send you a code to get back into your account.
              </p>

            
              <input
                className="auth-input"
                type="email"
                placeholder="Email"
                value={email}
                onChange={e=>setEmail(e.target.value)}
                disabled={sending}
              />

              {err && <p className="error-message">{err}</p>}

              <button className="primary-button" type="submit" disabled={sending||!email}>
                {sending ? 'Sending…' : 'Send verification code'}
              </button>

              <div className="divider"><span>OR</span></div>

              <button
                type="button"
                className="link-button bold"
                onClick={() => navigate('/Signup')}
              >
                Create new account
              </button>
            </form>
          )}

          {/* ---------- RESET ---------- */}
          {view==='reset' && (
            <form onSubmit={onResetSubmit} className="card-form">
              <h2 className="card-title">Reset password</h2>
              <p className="card-text">
                Enter the verification code sent to your email and choose a new password.
              </p>

              <label className="field-label">Verification code</label>
              <input
                className="auth-input"
                type="text"
                name="code"
                value={reset.code}
                onChange={onResetChange}
                placeholder="Code"
                disabled={resetting}
              />

              <label className="field-label">New password</label>
              <input
                className="auth-input"
                type="password"
                name="newPassword"
                value={reset.newPassword}
                onChange={onResetChange}
                placeholder="New password"
                disabled={resetting}
              />
              <PasswordRequirements password={reset.newPassword}/>

              <label className="field-label">Confirm password</label>
              <input
                className="auth-input"
                type="password"
                name="confirmPassword"
                value={reset.confirmPassword}
                onChange={onResetChange}
                placeholder="Confirm password"
                disabled={resetting}
              />

              {err && <p className="error-message">{err}</p>}

              <button className="primary-button" type="submit" disabled={resetting}>
                {resetting ? 'Resetting…' : 'Reset password'}
              </button>

              <button
                type="button"
                className="link-button"
                onClick={()=>setView('forgot')}
              >
                ← Back
              </button>
            </form>
          )}

          {/* ---------- SUCCESS ---------- */}
          {view==='success' && (
            <div className="success-message">
              <h2>Password reset successful!</h2>
              <p>You can now log in with your new password.</p>
              <button
                className="primary-button"
                onClick={() => navigate('/Login')}
              >
                Go to login
              </button>
            </div>
          )}

          {/* ---------- Barra Back to login ---------- */}
          <div className="bottom-card-bar" onClick={() => navigate('/Login')}>
            Back to login
          </div>
        </div>

      </div>
    </>
  );
}
